import { PlatformId, PLATFORM_SERVICE_MAP } from "@/constants/platforms";
import { PermissionLevel } from "@/utils/constants";

export interface PlatformSelection {
  [key: string]: boolean;
}

export interface BuildPermissionsParams {
  business: string;
  team: string;
  platforms: PlatformSelection;
  accessLevel?: PermissionLevel;
}

export function buildPermissions({
  business,
  team,
  platforms,
  accessLevel = "w",
}: BuildPermissionsParams): string[] {
  if (!business || !team) {
    return [];
  }

  const permissions: string[] = [];

  Object.entries(platforms).forEach(([platformId, isSelected]) => {
    if (isSelected) {
      const serviceName = PLATFORM_SERVICE_MAP[platformId as PlatformId];
      if (serviceName) {
        permissions.push(`${business}.${team}.${serviceName}.${accessLevel}`);
      }
    }
  });

  return permissions;
}

